import {
  Alert,
  AlertColor,
  AlertTitle,
  Link,
  Stack,
  Typography,
} from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import React from 'react';

type AlertVariant = 'standard' | 'filled' | 'outlined';

interface GeneralAlertProps {
  title?: string;
  body?: string | React.ReactNode;
  variant?: AlertVariant;
  severity?: AlertColor;
  action?: string;
  actionCallback?: () => void;
  onClose?: () => void;
  link?: string;
  alertTextColor?: string;
  icon?: React.ReactNode;
  sx?: SxProps<Theme>;
}

export const GeneralAlert = ({
  title,
  body,
  severity,
  action,
  variant,
  link,
  actionCallback,
  alertTextColor,
  onClose,
  icon,
  sx,
}: GeneralAlertProps) => {
  return (
    <Alert
      severity={severity}
      variant={variant}
      onClose={onClose}
      sx={sx}
      icon={icon}>
      {title && <AlertTitle color={alertTextColor}>{title}</AlertTitle>}{' '}
      <Stack gap={0.5}>
        {body && typeof body === 'string' ? (
          <Typography variant="body2" color={alertTextColor}>
            {body}
          </Typography>
        ) : (
          body
        )}
        {action && (
          <Link
            href={link}
            target="_blank"
            color={alertTextColor}
            onClick={actionCallback}
            underline="always"
            sx={{
              '&.MuiLink-root:hover': {
                cursor: 'pointer',
                color: alertTextColor,
              },
            }}>
            <Typography variant="subtitle2" color={alertTextColor}>
              {action}
            </Typography>
          </Link>
        )}
      </Stack>
    </Alert>
  );
};
